import { render } from "./TradingStrategy.vue?vue&type=template&id=2b6ed702"
import script from "./TradingStrategy.vue?vue&type=script&lang=js"
export * from "./TradingStrategy.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__